import { Component, Input, OnDestroy } from '@angular/core';
import { NbDialogRef,  NbDialogService } from '@nebular/theme';
import { FluxStockService } from '../../../@core/data/rest/fluxstock/fluxstock-service';
import { FactureService } from '../../../@core/data/rest/facture/facture-service';

import { FluxStock } from '../../../@core/data/model/fluxstock';
import { plainToClass } from 'class-transformer';
import { ProduitService } from '../../../@core/data/rest/produit/produit-service';
import { Produit } from '../../../@core/data/model/produit';
import { SharedMethods } from '../../../util/sharedMethods-service';
import { Validator } from '../../../@core/data/model/validator';
import { ProduitFormComponent } from '../../produit/produitform/produitform.component';
import { isDefined } from '@angular/compiler/src/util';
import { AuthService } from '../../../auth/auth.service';
import { Commande } from '../../../@core/data/model/commande';



@Component({
  // tslint:disable-next-line:component-selector
  selector: 'nb-name-prompt',
  templateUrl: './fluxstockform.component.html' ,
  styles: [`
    button {
      margin: 1rem;
    }
  `],
})
export class FluxStockFormComponent implements OnDestroy {

  private alive = true;

  @Input() fluxstockedit: FluxStock;
  @Input() saveToApi: boolean;
  @Input() typeSaisir: string;
  produit: Produit[];
  // @Input() commandes: Commande[];


  produitloading = false;
  listeProduit: Produit[];

  select: number;

  selectedItems = [];
  dropdownSettings = {};


  constructor(
      protected dialogRef: NbDialogRef<FluxStockFormComponent>,
      public produitService: ProduitService,
      public fluxstockService: FluxStockService,
      private dialogService: NbDialogService,
      public sharedMethods: SharedMethods,
      public factureService: FactureService,
      public authService: AuthService) {
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnInit(): void {

    this.authService.logoutEvent.subscribe(() => {

      this.dialogRef.close();

    });

    /* for ( let i = 0; i < this.produitService.produits.length; i++) {
        this.dropdownList.push({item_id: this.produitService.produits[i].id, item_text: this.produitService.produits[i].designation });
    } */

    if (this.fluxstockedit.id !== 0) {
        this.selectedItems = [
          this.fluxstockedit.produit,
        ];
    }

    this.dropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'designation',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    searchPlaceholderText: 'recherche',
    noDataAvailablePlaceholderText: 'Aucune donnée trouvée',
    closeDropDownOnSelection: true,
    };

    // chargement produit
    if (this.typeSaisir !== 'livraison' && this.typeSaisir !== 'retour' ) {

        this.getProduits();

    } else {

      const prod = [];

      if (this.typeSaisir === 'livraison' && this.factureService.invoiceSelected !== undefined ) {

        // this.produit = [];
        for ( let i = 0; i < this.factureService.invoiceSelected.commandes.length; i++) {
          prod.push(this.factureService.invoiceSelected.commandes[i].produit);
        }
        // pr = null;

        this.produit = this.filtreProduitStockable(prod);

      } else {

        if (this.typeSaisir === 'retour' && this.factureService.invoiceSelected !== undefined && this.factureService.invoiceSelected !== null && this.factureService.invoiceSelected.bordereaux_livraison !== undefined && this.factureService.invoiceSelected.bordereaux_livraison !== null) {

          this.produit = [];

          const bordereaux = this.factureService.invoiceSelected.bordereaux_livraison;

          for ( let i = 0; i < bordereaux.length; i++) {

            const flux = bordereaux[i].fluxstock;

            for ( let compt = 0; compt < flux.length; compt++) {

                const itemIndex = this.produit.findIndex(item => item.id === flux[compt].produit.id);

                if (itemIndex < 0)
                this.produit.push(flux[compt].produit);
            }

            // tslint:disable-next-line:no-console
            // console.log(this.fluxstockedit.bordereau.facture.bordereaux_livraison[i].fluxstock);

          }

        } else {

          this.getProduits();

        }


      }

    }



  }


  getProduits() {

    if (this.produitService.produits === undefined) {

      this.produitService.getProduits().then( produits => {

        this.produit = this.filtreProduitStockable(produits);

      });

    } else {
      this.produit = this.filtreProduitStockable(this.produitService.produits);
    }

  }

  filtreProduitStockable(produits: Produit[]): Produit[] {

    const result = [];

    produits.forEach( elem => {
      // if (elem.is_stockable)
      result.push(elem);

    });

    return result;

  }


  onItemSelect(item: any) {
    // tslint:disable-next-line:no-console
   /*  for ( let i = 0; i < this.produitService.produits.length; i++) {
      if (this.produitService.produits[i].id === item.item_id ) {
        this.fluxstockedit.produit = this.produitService.produits[i];
      }
    } */
    this.fluxstockedit.produit = item;

    let cmd: Commande;

    if (this.fluxstockedit.bordereau.facture !== undefined && this.fluxstockedit.bordereau.facture !== null) {
      cmd =  plainToClass(Commande,  this.factureService.invoiceSelected.cmdByProd(item.id) as object);
      // recuperation du prix par defaut du produit
      cmd.facture = this.fluxstockedit.bordereau.facture;
      // console.log( cmd.facture );
      
    
      this.fluxstockedit.prix_unitaire = cmd.prixUnitaireRetour;
      // this.fluxstockedit.remise = this.fluxstockedit.facture.cmdByProd(item.id).remise;
      // this.fluxstockedit.tva = this.fluxstockedit.bordereau.facture.tva;
    } else {

      // recuperation du prix par defaut du produit
      for ( let i = 0; i < this.produitService.produits.length; i++) {

          if (this.produitService.produits[i].id === item.id ) {

              if (this.fluxstockedit.type_flux === 'sortie' && this.fluxstockedit.bordereau.facture !== undefined && this.fluxstockedit.bordereau.facture !== null) {

                    // tslint:disable-next-line:no-console
                    // console.log(this.fluxstockedit.facture.partenaire);

                    if (this.fluxstockedit.bordereau.facture.partenaire !== undefined && this.fluxstockedit.bordereau.facture.partenaire !== null && this.fluxstockedit.bordereau.facture.partenaire.plan_tarifaire !== null && this.fluxstockedit.bordereau.facture.partenaire.plan_tarifaire !== undefined && this.fluxstockedit.bordereau.facture.partenaire.plan_tarifaire.tarifs !== null && this.fluxstockedit.bordereau.facture.partenaire.plan_tarifaire.tarifs !== undefined) {

                      const itemIndex = this.fluxstockedit.bordereau.facture.partenaire.plan_tarifaire.tarifs.findIndex( elem => elem.idproduit.toString() === this.produitService.produits[i].id.toString());

                      if (itemIndex > -1)
                      this.fluxstockedit.prix_unitaire = this.fluxstockedit.bordereau.facture.partenaire.plan_tarifaire.tarifs[itemIndex].prix;
                      else
                      this.fluxstockedit.prix_unitaire = this.produitService.produits[i].prix_detail;

                    } else {

                      this.fluxstockedit.prix_unitaire = this.produitService.produits[i].prix_detail;

                    }


              } else {

                    this.fluxstockedit.prix_unitaire = this.produitService.produits[i].prix_achat;

              }

              return;
          }

      }

    }


    this.fluxstockedit.quantite = 1;

    // alert(JSON.stringify(item));
    // tslint:disable-next-line:no-console
    // console.log(item);

  }

  onSelectAll(items: any) {
    // tslint:disable-next-line:no-console
    console.log(items);
  }


  cancel() {
    if (this.fluxstockService.iSconnecting === false) {
        this.dialogRef.close();
    }
  }

  submit() {
    // validation des données
    /* const valid = this.sharedMethods.validatePartner(this.partner, this.data);
    if (valid.result === false) {
      event.confirm.reject();
      this.sharedMethods.toastShow('error', valid.title, valid.message);

      // on stop l'exécution de la methode directement
      return;
    } */
    let valid: Validator;

    // Vérification des quantités
    valid = this.sharedMethods.validateFluxstock (this.fluxstockedit, null);




    if (valid.result) {

      if ( !this.saveToApi) {

        // on vide le flux de la facture pour liberer la memoire
        this.fluxstockedit.bordereau = null;
        this.dialogRef.close(this.fluxstockedit);

      } else {

          if (this.fluxstockService.iSconnecting === false) {

              // tslint:disable-next-line:no-console
              // console.log(this.fluxstockedit);
              this.fluxstockService.saveFluxstock(this.fluxstockedit).then( fluxstock => {

                  this.fluxstockedit.id = fluxstock.id;

                  // on vide le flux de la facture pour liberer la memoire
                  this.fluxstockedit.bordereau = null;

                  this.dialogRef.close(this.fluxstockedit);
                  // alert(JSON.stringify(this.fluxstockedit));

              });
          }

      }

    } else {

        this.sharedMethods.toastShow('error', valid.title, valid.message);

    }


  }

  addproduct() {

    const prod = new Produit;
    this.editProduit(prod, 'add');

  }

  editProduit(product: Produit, typeEdit: string) {

    // this.dialogIsNotShow = false;
    const closeOnBackdropClick = false;
    this.dialogService.open(ProduitFormComponent, {
      closeOnBackdropClick,
      context: {
        produitEdit : product,
      },
    }).onClose.subscribe(data => {

        if ( isDefined(data)) {

          // on met à jour le produit du flux et le partenaire selectionner
          this.fluxstockedit.produit = data;

          this.selectedItems = [
            data,
          ];

          /* if (typeEdit === 'update' ) {
            this.source.update(product, data);
            this.sharedMethods.sweetalert('success', ' Produit Modifié', '');
          }

          if (typeEdit === 'add' ) {
            this.source.prepend(data);
            this.sharedMethods.sweetalert('success', ' Produit créer avec succèss', '');
          } */

        }
    });

  }


  ngOnDestroy() {
    // clearInterval(this.intervalId);
    this.alive = false;
    // this.settingService.getCurrentDay();
    // alert('')

  }


}
